export const defaultSoftwareExperienceOptions = [
  "MS Excel",
  "MS Word",
  "MS PowerPoint",
  "Tally",
  "QuickBooks Online",
  "QuickBooks Desktop",
  "SAP",
];
